import { render, staticRenderFns } from "./_selectPlanStep.vue?vue&type=template&id=88b10f22"
import script from "./_selectPlanStep.vue?vue&type=script&lang=js"
export * from "./_selectPlanStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports